import { FrameDetailsFeatures } from '@/features';
import { Flex } from '@chakra-ui/react';

type FrameDetailsInfoProps = {
  frameId: number | undefined;
  hidePartsForFrame?: boolean;
  showPartsForFrameFilterWithOnlyPrefixes?: string[];
};

const FrameDetailsInfo = (props: FrameDetailsInfoProps) => {
  const {
    frameId,
    hidePartsForFrame = false,
    showPartsForFrameFilterWithOnlyPrefixes = [],
  } = props;

  return (
    <Flex flexDirection="column" width="full" gapY={4}>
      <FrameDetailsFeatures.FramePreview frameId={frameId} />

      {!hidePartsForFrame && (
        <FrameDetailsFeatures.PartsForFrame
          frameId={frameId}
          showPartsForFrameFilterWithOnlyPrefixes={
            showPartsForFrameFilterWithOnlyPrefixes
          }
        />
      )}
    </Flex>
  );
};

export default FrameDetailsInfo;